var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / Outline Tick"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Icon \xD0\xA1olor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.86338 13.6464C5.58738 13.6464 5.32338 13.534 5.13438 13.336L0.271382 8.23196C-0.107618 7.83578 -0.086618 7.21195 0.315382 6.83943C0.718382 6.4669 1.35138 6.48661 1.72838 6.88279L5.85338 11.2102L14.2614 2.14146C14.6354 1.73839 15.2674 1.71178 15.6754 2.07839C16.0824 2.445 16.1104 3.06883 15.7384 3.46994L6.60138 13.3251C6.41438 13.5281 6.14838 13.6444 5.87038 13.6464H5.86338Z",
    fill: "#1B8828"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGreenCheck);
export default __webpack_public_path__ + "static/media/icon-green-check.4917943c79e1913c9c24feec546ac0e0.svg";
export { ForwardRef as ReactComponent };